import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

import { TextRendererComponent } from 'shared/search/search-results/text-renderer/text-renderer.component';


@Component({
  moduleId: module.id,
  selector: 'fitments-text-renderer',
  templateUrl: 'fitments-text-renderer.component.html',
  styleUrls: ['fitments-text-renderer.component.scss'],
})
export class FitmentsTextRendererComponent extends TextRendererComponent {
  @Input() researched: boolean = false;
  @Input() tooltipTextsMap: any;
  @Input() showIconForEmptyVal: boolean = false;
  @Input() actionButtonTitle: string = 'Research';
  @Input() isClickable: boolean = true;
  @Input() isEditable: boolean = false;

  @Output() textClick = new EventEmitter<any>();
  @Output() highlightedValueClick = new EventEmitter<any>();
  @Output() editBtnClick = new EventEmitter<any>();

  get showTooltip(): boolean {
    if (!this.tooltipTextsMap) { return false; }
    return _.has(this.tooltipTextsMap, this.columnText);
  }

  // if value is empty, show icon for researchable columns
  // and Add placaholder for editable columns
  get showPlaceholder(): boolean {
    return this.showIconForEmptyVal &&
           !(this.hasColumnText && _.trim(this.columnText).length > 0);
  }

  get highlightedColor(): string {
    return _.get(this.row, `highlightedColumns.${this.column.col}.color`, '');
  }

  get hasColumnText(): boolean {
    return !_.isNil(this.columnText);
  }

  get objArrayText(): string {
    const objArray = this.row[this.column.col] || [];
    switch (this.column.col) {
      case 'qualifiers':
        return objArray.map(item => item.text).join(', ');
      case 'part_terminologies':
        return objArray.map(item => item.name).join(', ');
      default:
        return objArray.map(item => item.name).join(', ');
    }
  }

  // todo remove after part types edit implementing
  get isAddingBlocked(): boolean {
    return this.column.col === 'part_terminologies' || this.column.col === 'qualifiers';
  }

  get isInvalidCol(): boolean {
    return !!(this.row.validation && this.row.validation[this.column.col]?.length);
  }

  onInfoIconBtnClick(row: any) {
    this.infoIconClick.emit({row, column: this.column});
  }

  onEditBtnClick(row: any) {
    this.editBtnClick.emit({row, column: this.column});
  }

  onHighlightedValueClick(row: any) {
    this.highlightedValueClick.emit({row, column: this.column});
  }

  onItemClick() {
    if (!this.hasColumnText) { return; }
    this.textClick.emit({row: this.row, column: this.column});
  }
}
